import api from '../api'
import find from 'lodash/find'
import {fetchUser} from './user'
import {fetchPollsForSet} from './polls'
import {fetchControl} from './control'
import {fetchSections} from './sections'
import {fetchService} from './service'
import {fetchMeta} from './meta'
import {syncClock} from './syncClock'
import {fetchGeoInfo} from './geoInfo'
import {fetchARepoAndPermissions,fetchRepos} from './repos'	
import {fetchLocksForRepo} from './locks'
import store from '../store'
import {fetchBilling} from './billing'
import {fetchReviewsForUser} from './reviews'
 import {fetchSubmissions} from './submissions'

 
export function loadSetEditorData(setId,userId) {
	if(setId !=='newSet'){
		return (dispatch) => {
			api.fetch(`/sets/${setId}`)
				.then((response) => {
					dispatch({ type: 'FETCH_A_SET_SUCCESS', response })
					if(response.repo){
						let promises=[]
						promises.push(dispatch(fetchARepoAndPermissions(response.repo)))
						promises.push(dispatch(fetchLocksForRepo(response.repo)))

						Promise.all(promises).then(function () {
							const state = store.getState()
							const parentRepo = find(state.repos, {'id':response.repo})
							if(parentRepo && parentRepo.shared){
								let lockState='unlocked'
								const repoLocks=state.locks[response.repo]
								const lock = find(repoLocks, function(lock) {
    							return lock.item === setId
								})
						
								if(lock && state.user){
									if(lock.user !== state.user.id){
										lockState='lockedByAnotherUser'
									}
								}
								window.analytics.track('Open Shared Item',{
									itemType:'set',
									lockState:lockState
								})	

							}

						})

							
	


	
					}
 
					dispatch(fetchService())
					dispatch(fetchBilling())
					dispatch(fetchReviewsForUser())
					 dispatch(fetchRepos())
					dispatch(fetchControl())
					dispatch(fetchPollsForSet(setId))
					dispatch(fetchSections())
					dispatch(fetchUser(userId))
					dispatch(fetchMeta())
					dispatch(fetchGeoInfo())
					dispatch(fetchSubmissions())
					setTimeout(function() { //Start the timer
						dispatch(syncClock())
					},	5000)
					//dispatch(fetchMobileInfo())
				})
				.catch(err => {
	    		 })
		}
	}else{
		return (dispatch) => {
			api.fetch('/control')
				.then((response) => {
					dispatch({ type: 'FETCH_CONTROL_SUCCESS', response })
					dispatch(fetchService())
					dispatch(fetchBilling())
					dispatch(fetchRepos())
					dispatch(fetchReviewsForUser())
					dispatch(fetchControl())
					dispatch(fetchSections())
					dispatch(fetchUser(userId))
					dispatch(fetchMeta())
					dispatch(fetchGeoInfo())
					dispatch(fetchSubmissions())
					setTimeout(function() { //Start the timer
						dispatch(syncClock())
					},	5000)
					//dispatch(fetchMobileInfo())
				})
				.catch(err => {
	    		 })
		}
	}
}

